/**
 * 환경 설정 유틸리티
 * VITE_DEV_MODE에 따라 자동으로 적절한 URL 선택
 */

const isDevMode = import.meta.env.VITE_DEV_MODE === 'true'

// API URL 자동 선택
export const API_BASE_URL = isDevMode 
  ? 'http://localhost:8000'
  : 'https://auto-backend-443714712477.us-central1.run.app'

// APP URL 자동 선택  
export const APP_URL = isDevMode
  ? 'http://localhost:3000'
  : (import.meta.env.VITE_APP_URL || 'https://app.terai.kr')

// 개발 모드 확인
export const IS_DEV_MODE = isDevMode

// 디버그 로그
if (isDevMode) {
  console.log('🔧 개발 모드 활성화')
  console.log('📡 API URL:', API_BASE_URL)
  console.log('🌐 APP URL:', APP_URL)
}

export default {
  API_BASE_URL,
  APP_URL,
  IS_DEV_MODE
}